import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import TruckIndexPage from '../containers/Trucks'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const TrucksPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'trucks') {
			dispatch(changeCurrent(['trucks']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={TruckIndexPage} exact />
		</Switch>
  )
}

TrucksPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

TrucksPage.defaultProps = {}

export default TrucksPage
